// @ts-nocheck

// Backend sends rounded value, so the combobooster computation is badly rounded by default
// We use this to round combobooster value to its closest bound. 12.4 -> 12.5 / 2.51 -> 2.5 / 2.49 -> 2.5 etc
// Bounds are 2.5 - 5 - 7.5 - 10 - 12.5 - 15 - 20 and 5 by 5 until 100%
export default (boosterValue) => {
  return Math.round(boosterValue / 2.5) * 2.5;
};
